import * as tslib_1 from "tslib";
import cx from 'classnames';
import * as React from 'react';
import { SpinnerSvg } from '@nextiva/next-ui';
import { ExclamationMarkSvg } from '../SvgIcons';
import Styles from "./ChartStub.css";
export var Modes;

(function (Modes) {
  Modes["GRAY"] = "gray";
  Modes["WHITE"] = "white";
})(Modes || (Modes = {})); // TODO: upgrade ChartStup, check with CRM


var ChartStub = function ChartStub(_a) {
  var isLoading = _a.isLoading,
      isEmpty = _a.isEmpty,
      children = _a.children,
      style = _a.style,
      withoutBorder = _a.withoutBorder,
      errorMessage = _a.errorMessage,
      withoutPlaceholder = _a.withoutPlaceholder,
      _b = _a.mode,
      mode = _b === void 0 ? Modes.WHITE : _b;

  var _c;

  var chartStubStyle = {};

  if (withoutBorder) {
    chartStubStyle.border = 'none';
  }

  if (withoutPlaceholder) {
    chartStubStyle.background = 'none';
    chartStubStyle.border = 'none';
  }

  if (!isLoading && !isEmpty) {
    return children;
  }

  return React.createElement("div", {
    "data-test": "chart-stub",
    className: Styles.chartStub,
    style: tslib_1.__assign({}, chartStubStyle, style)
  }, React.createElement("div", {
    className: cx(Styles.placeholder, (_c = {}, _c[Styles.placeholderGray] = mode === Modes.GRAY, _c[Styles.placeholderWhite] = mode === Modes.WHITE, _c))
  }), isLoading && React.createElement("div", {
    className: Styles.chartStub,
    style: tslib_1.__assign({}, chartStubStyle, style)
  }, React.createElement(SpinnerSvg, {
    size: 30
  }), React.createElement("div", {
    className: Styles.description
  }, "Loading\u2026")), isEmpty && !isLoading && React.createElement("div", {
    className: Styles.chartStub,
    style: tslib_1.__assign({}, chartStubStyle, style)
  }, React.createElement(ExclamationMarkSvg, null), React.createElement("div", {
    className: Styles.description
  }, errorMessage ? React.createElement("span", null, errorMessage) : React.createElement(React.Fragment, null, React.createElement("span", null, "There is no data in the selected period.")))));
};

export default ChartStub;